import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ProductSelectPage} from '../product-select/product-select.page';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {EquipmentSelect} from '../equipment-select/equipment-select';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'app-equipment-list',
    templateUrl: './equipment-list.page.html',
    styleUrls: ['./equipment-list.page.scss'],
})
export class EquipmentListPage implements OnInit {

    @Input() document: DocumentModel;
    detailsArr: DetaillineDTOModel[];
    delete: boolean;
    detailLine = new DetaillineDTOModel();

    constructor(public modalController: ModalController) {
    }

    ngOnInit() {
        this.delete = false;
        this.detailsArr = this.document.detailLines;
    }

    async addProductModal() {
        const modal = await this.modalController.create({
            component: ProductSelectPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'detailLine': this.detailLine,
                'detailsArr': this.detailsArr,
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.detailsArr = dataReturned.data;
            }
        });

        return await modal.present();
    }

    async addEquipmentModal() {
        const modal = await this.modalController.create({
            component: EquipmentSelect,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'detailLine': this.detailLine,
                'detailsArr': this.detailsArr,
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.detailsArr = dataReturned.data;
                console.log(this.detailsArr);
            }
        });

        return await modal.present();
    }

    async cancelModal() {
        await this.modalController.dismiss(this.detailsArr);
    }

    editDetailLine(det: DetaillineDTOModel) {
        this.detailLine = det;
        if (det.pdesc) {
            this.addEquipmentModal();
        }
        if (det.plu) {
            this.addProductModal();
        }
        this.detailLine = new DetaillineDTOModel();
    }
}
